import React, { useEffect } from "react";
import "aos/dist/aos.css"; // AOS library for animations
import AOS from "aos";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faRoad, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import "./AboutUs.scss"; // Custom styles
import Header from "../../components/ActivePath/Header";

const AboutUs: React.FC = () => {
    useEffect(() => {
        AOS.init({
          duration: 1000, // Animation duration in milliseconds
          once: false, // Animation happens only once
        });
      }, []);
  return (
    <section className="about-us" id="about-us">
        <Header pageTitle="" breadcrumb="About Us" />
      <div className="container">
        <h2 className="section-title" data-aos="fade-up">About Us</h2>
        <div className="content">
          <div className="info-card" data-aos="fade-right">
            <div className="card-icon">
              <FontAwesomeIcon icon={faHistory} />
            </div>
            <div className="card-text">
              <h3>Our History</h3>
              <p>
                Established in 1984 with the blessings of Sri Sri Sri Mallikarjuna Murugharajendra Mahaswamiji, 
                SJMP is a premier institute affiliated with D.T.E. Bengaluru and approved by AICTE, New Delhi.
              </p>
            </div>
          </div>
          <div className="info-card" data-aos="fade-up">
            <div className="card-icon">
              <FontAwesomeIcon icon={faRoad} />
            </div>
            <div className="card-text">
              <h3>Prime Location</h3>
              <p>
                Located next to the Bangalore-Honnavar National Highway-206, the institute is well connected by 
                road and rail, just 200 km from Bangalore.
              </p>
            </div>
          </div>
          <div className="info-card" data-aos="fade-left">
            <div className="card-icon">
              <FontAwesomeIcon icon={faGraduationCap} />
            </div>
            <div className="card-text">
              <h3>Excellence in Education</h3>
              <p>
                Over 34 years, we have nurtured students into professionals working across Private and Public 
                sectors nationwide.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;

